import { useContext } from "react";
import { ZodType } from "zod";

import { get } from "@/browser/http";
import { UserContext } from "@/components/User";
import { applyHeaders, parseResponse } from "@/core/api";
import { usePageableQuery } from "@/core/queries";
import { EntityType } from "@/core/types";
import { compose } from "@/core/url";

import { RelatedEntityKey } from "../types";

interface UseRelatedEntitiesQueryParams<T> {
  entityType: EntityType;
  entityId: string | number;
  relatedEntityKey: RelatedEntityKey;
  url: string;
  resultType: ZodType<T, any, any>;
}

export const useRelatedEntitiesQuery = <T>({
  entityType,
  entityId,
  relatedEntityKey,
  url,
  resultType,
}: UseRelatedEntitiesQueryParams<T>) => {
  const { contextCompany, contextConsultantProfileId } = useContext(UserContext);

  const queryKey = [contextConsultantProfileId, `related-entities`, entityType, entityId, relatedEntityKey];

  return usePageableQuery(queryKey, params => {
    const companyId = contextCompany?.id;
    const apiUrl = compose(url, {}, params);

    return get(apiUrl, applyHeaders({ companyId })).then(parseResponse<T>(resultType));
  });
};
